import { useState, useRef, useEffect } from 'react'
import { inject, observer } from 'mobx-react';
import { CommonService, UserService } from "../../../services";
import { createMultipleRef, validateInput, getValueInputRef, setOptions } from '../../../helpers'
import { Card, Modal, Button, Input, InputPassword, ModalAlert, Select, FormLoading, ExportExcel } from '../../../components'
import DataGrid, { SearchPanel, Toolbar, Item, Paging, Pager, Column, HeaderFilter } from 'devextreme-react/data-grid';
import { PlusIcon, RefreshIcon, CheckIcon } from '@heroicons/react/outline';
import { LockOutlined, CheckCircleOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import '../style.css'

let firstRender = false
const RegisterPlan = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['register', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let { onNext } = props
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [billing, setBilling] = useState("monthly")

  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  const [dataForm, setDataForm]: any = useState({
    "id": "",
    "employee_code": "",
    "username": "",
    "password": "",
    "first_name": "",
    "last_name": "",
    "email": "",
    "phone_no": "",
    "position": "",
    "user_status": "Y",
    "user_group_id": "",
    "role_level": ""
  })

  const gridRef: any = useRef(null);
  const inputRef: any = useRef([]);
  createMultipleRef(inputRef, 7)


  const tiers = [
    {
      name: 'PALMOTION',
      id: 'tier-enterprise',
      href: '#',
      priceMonthly: '฿399',
      description: 'Dedicated support and infrastructure for your company.',
      features: [
        'Unlimited products',
        'Unlimited subscribers',
        'Advanced analytics',
        'Dedicated support representative',
        'Marketing automations',
        'Custom integrations',
      ]
    },
    {
      name: 'PALMOTION PRO AI',
      id: 'tier-enterprise',
      href: '#',
      priceMonthly: '฿799',
      description: 'Dedicated support and infrastructure for your company.',
      features: [
        'Unlimited products',
        'Unlimited subscribers',
        'Advanced analytics',
        'Dedicated support representative',
        'Marketing automations',
        'Custom integrations',
      ]
    },
  ]


  const features = [
    {
      icon: <LockOutlined className="text-xl" />,
      title: "ปลอดภัย 100%",
      desc: "ข้อมูลของคุณได้รับการเข้ารหัส",
    },
    {
      icon: <CheckCircleOutlined className="text-xl" />,
      title: "ยกเลิกได้ทุกเมื่อ",
      desc: "ไม่มีข้อผูกมัดระยะยาว",
    },
    {
      icon: <CustomerServiceOutlined className="text-xl" />,
      title: "สนับสนุน 24/7",
      desc: "ทีมงานพร้อมให้ความช่วยเหลือ",
    },
  ];




  return (
    <>
      <div className="mt-5 md:col-span-2 md:mt-0 space-y-6">
        <div className="text-center space-y-4">
          <div className="mx-auto max-w-4xl">
            <p className="mt-2 text-3xl font-semibold tracking-tight text-balance">
              {t('register_title')}
            </p>
          </div>
          <p className="mx-auto mt-2 max-w-xl text-lg text-gray-700 font-medium text-pretty sm:text-xl/8">
            {t('register_desc')}
          </p>

          <div
            role="tablist"
            aria-label="Billing period"
            className="inline-flex items-stretch rounded-full border register-border overflow-hidden bg-white"
          >
            <button
              role="tab"
              aria-selected={billing === "monthly"}
              onClick={() => setBilling('monthly')}
              className={`px-6 py-2 text-sm font-medium transition-colors duration-150 rounded-l-full w-28 ${billing === "monthly" ? "register-btn-bg text-white" : "text-gray-800 hover:bg-red-50"}`}
            >
              {t('per_month')}
            </button>
            <div className="w-px bg-red-700" />
            <button
              role="tab"
              aria-selected={billing === "yearly"}
              onClick={() => setBilling("yearly")}
              className={`px-6 py-2 text-sm font-medium transition-colors duration-150 rounded-r-full w-28 ${billing === "yearly" ? "register-btn-bg text-white" : "text-gray-800 hover:bg-red-50"}`}
            >
              {t('per_year')}
            </button>
          </div>
        </div>

        <div className="mx-auto grid max-w-lg grid-cols-1 items-center gap-x-6  sm:gap-y-0 lg:max-w-3xl lg:grid-cols-2">
          {tiers.map((tier, tierIdx) => (
            <div
              key={tier.id}
              className="bg-white rounded-3xl p-8 register-border sm:p-10 text-center"
            >
              <h3
                id={tier.id}
                className="text-black font-bold text-2xl"
              >
                {tier.name}
              </h3>
              <p className="mt-4 gap-x-2">
                <span className="text-black text-3xl font-semibold tracking-tight"   >
                  {tier.priceMonthly}
                </span>
                <span className="text-gray-600 text-base">
                  {`  /  ${t('month')}`}
                </span>
              </p>

              <ul
                role="list"
                className="text-gray-700 mt-8 space-y-3 text-sm/6 sm:mt-10"
              >
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <CheckIcon
                      aria-hidden="true"
                      className="text-green-500 h-6 w-5 flex-none"
                    />
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="flex flex-col justify-center space-y-4 mt-10">
                <button
                  aria-describedby={tier.id}
                  className="text-black ring-1 ring-gray-500 hover:bg-red-200 block rounded-full px-2 py-2.5 text-center text-sm font-semibold w-72"
                // className="register-btn-bg text-white hover:bg-red-200 block rounded-full px-3.5 py-2.5 text-center text-sm font-semibold"
                >
                  {t('choose_plan')}
                </button>

                <button
                  aria-describedby={tier.id}
                  className="text-black ring-1 ring-gray-500 hover:bg-red-200 block  rounded-full px-3.5 py-2.5 text-center text-sm font-semibold w-72"
                // className="register-btn-bg text-white hover:bg-red-200 block rounded-full px-3.5 py-2.5 text-center text-sm font-semibold"
                >
                  {t('start_trial')}
                </button>
              </div>

            </div>
          ))}
        </div>

        <div className="flex justify-center text-center space-y-4">
          <button
            className="register-btn-bg text-white hover:bg-red-600  block rounded-full px-3.5 py-2.5 text-center text-sm font-semibold w-72"
            onClick={() => onNext()}
          >
            {t('continue')}
          </button>
        </div>


        <div className="flex justify-center items-start gap-16 mt-10 text-center">
          {features.map((item, i) => (
            <div key={i} className="max-w-[200px] flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 mb-3">
                {item.icon}
              </div>
              <h3 className="text-base font-semibold text-black mb-1">{item.title}</h3>
              <p className="text-sm text-gray-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
      {/* <ModalAlert
        {...optionAlert}
        onOk={() => {
          let { action } = optionAlert
          if (["create", "update"].includes(action.name))
            saveData()
          else if (action.name === "delete")
            deleteUser(action.id)
          else if (action.name === "reset-pass")
            resetPassword(action.id)

          setOptionAlert(setOptions({
            defaultOption: alert,
            show: false
          }))
        }}
        onCancel={() => {
          setOptionAlert(setOptions({
            defaultOption: alert,
            show: false
          }))
        }}
      /> */}
    </>
  )
}))

export default RegisterPlan